<div class="auth-transfer-container">
  <div class="flex flex-col items-center gap-1">
    <span class="flex flex-row items-center gap-3">
      <img src={{icon}} height="60" width="60" alt="logo" />
      <img src={{brand}} width="300" height="auto" alt="Logo" />
    </span>
    <div class="flex flex-col gap-4 justify-center">
      @if (loading) {
        <span>{{ loadingMessage }}</span>
        <div class="flex justify-center">
          <mat-spinner diameter="45" style="color: rgb(62,127,126)"></mat-spinner>
        </div>
      }
      @else {
        <p>{{ errorMessage }}</p>
        <div class="flex flex-row justify-center">
          @for (action of currentErrorConfig?.actions ?? []; track $index) {
            <button mat-raised-button color="{{action.color??'primary'}}" (click)="handleAction(action)">{{ action.label }}</button>
          }
        </div>
      }
    </div>
  </div>
</div>
